import {
	Component,
	OnInit,
	OnChanges,
	ElementRef,
	Input,
	ChangeDetectorRef,
	Output,
	EventEmitter,
} from "@angular/core";
import { CourseContextModelService } from "app/core/models/course-context-model.service";
import { AppConstants } from "app/core/vo/app-constants";
@Component({
	selector: "app-toggle-transcript-text",
	templateUrl: "./toggle-transcript-text.directive.html",
	styleUrls: ["./toggle-transcript-text.directive.css"],
})
export class ToggleTranscriptTextDirective implements OnChanges {
	@Input() useToggle?: Boolean;
	@Input() transcript_text: string;
	@Input() width?: string;
	@Input() height?: string;
	@Input() borderradius?: string;
	@Input() borderwidth?: string;
	@Input() bordercolor?: string;
	@Input() borderstyle?: string;
	@Input() hpadding?: string;
	@Input() vpadding?: string;
	@Input() bgcolor?: string;
	@Input() fontsize?: string;
	@Input() fontcolor?: string;
	@Input() showTranscript: Boolean;
	@Input() type: string;
	@Output() toggleTranscriptEvent: EventEmitter<any> = new EventEmitter<any>();
	@Input()
	public textDirection: string;
	public device: string;
	public bshowTranscript: Boolean;
	private el: HTMLElement;
	public iOSDevice: Boolean = false;
	public changePosition: boolean = false;
	constructor(
		private elementRef: ElementRef,
		private changeDetector: ChangeDetectorRef,
		private courseContextModel: CourseContextModelService
	) {
		this.el = elementRef.nativeElement;
	}
	ngOnInit() {
		this.iOSDevice = navigator.platform.indexOf("MacIntel") != -1;
		if (
			/iPhone|ipad/i.test(navigator.userAgent) ||
			(this.iOSDevice && window.innerWidth <= 1024)
		) {
			this.device = "ios";
		} else {
			this.device = "";
		}
	}
	ngOnChanges(changes) {
		console.log("changes :", changes);
	}
	ngAfterViewInit() {
		if (!this.el) return;
		this.bshowTranscript = this.useToggle ? false : true;
		this.changePosition =
			this.courseContextModel.currentLanguage == AppConstants.US_ENGLISH
				? true
				: false;
	}
	public toggleTranscript() {
		this.bshowTranscript = !this.bshowTranscript;
		this.toggleTranscriptEvent.emit();
	}
}
